import ReactRoutes from "./routes";

function App() {
  return (
    <ReactRoutes />
  );
}

export default App;
